/**
 * Matches names made up of one or more letters from any language (`\p{L}`),
 * combining accent marks (`\p{M}`), spaces, periods, apostrophes and hyphens.
 * Digits and every other special character are rejected.
 *
 * Allowed: "Renée", "José Álvarez", "Anna-Maria", "O'Brien", "J. R. Smith", "大翔"
 * Rejected: "Sitter123", "Anna_Maria", "user@example.com", "" (empty)
 */
export const VALID_NAME_PATTERN = /^[\p{L}\p{M} .'-]+$/u;

export const INVALID_NAME_MESSAGE = 'Use only letters a-z. Remove all numbers and special characters.';

export const isValidName = (name: string): boolean => VALID_NAME_PATTERN.test(name);

/**
 * Display names end in an abbreviated last initial ("Taylor D."). Copy that adds
 * its own punctuation has to drop that period, or it reads "Taylor D.?".
 */
export const nameWithoutTrailingPeriod = (name: string): string => name.replace(/\.$/, '');
